// UI
import Box from '../ui/Box'

// Dayjs
import dayjs from 'dayjs'

// Next
import { Link } from 'react-router-dom'

// Icons
import { IconQrcode } from '@tabler/icons-react'

export default function OrderWarrantiesDisplay({ warranties }) {
    return (
        <Box title="Garanties associées">
            {warranties.length === 0 && (
                <div className="text-center text-gray-500 my-5">
                    Aucune garantie associée
                </div>
            )}

            {warranties.length > 0 && (
                <div className="flex flex-col border rounded-xl overflow-hidden divide-y">
                    {warranties.map((warranty) => (
                        <Link
                            key={warranty.id}
                            to={'/warranties/' + warranty.code}
                            className="flex items-center gap-3 p-3 even:bg-gray-50 hover:bg-gray-50/80 transition-colors no-underline text-inherit"
                        >
                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-50 text-green-600 shrink-0">
                                <IconQrcode size={18} />
                            </div>

                            <div className="flex flex-col gap-0.5 min-w-0">
                                <span className="text-sm font-medium text-blue-600">
                                    {warranty.code}
                                </span>

                                {warranty.component?.name && (
                                    <span className="text-sm text-gray-500 truncate">
                                        {warranty.component.name}
                                    </span>
                                )}
                            </div>

                            <div className="ml-auto flex items-center gap-3 shrink-0">
                                <div className="text-sm text-gray-500 text-right">
                                    <div>{dayjs(warranty.warranty_start_at).format('ll')}</div>
                                    <div className="text-gray-400">
                                        → {dayjs(warranty.warranty_end_at).format('ll')}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </Box>
    )
}
